import { FC, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { ThemeContext } from 'styled-components';
import { EntityType, ProjectStage } from '../../../../enums';
import usePortal from '../../../../hooks/portal/UsePortal';
import useProject from '../../../../hooks/project/UseProject';
import {
  StageBodyText,
  StageInner,
  StageWrapper,
} from '../../../../main/theme';
import { showModal } from '../../../../store/modal';
import { updateActiveProjectStage } from '../../../../store/project-stage';
import ActionBar from '../../../ActionBar/ActionBar';
import AdvancedSetting from '../../../AdvancedSetting/AdvancedSetting';
import FeatureButton, {
  FeatureButtonSize,
} from '../../../FeatureButton/FeatureButton';
import { ModalTypes } from '../../../Modal/Modal';

const ProjectItemPortalConfigurationStage: FC = () => {
  const dispatch = useDispatch();
  const themeContext = useContext(ThemeContext);
  const { portal } = usePortal();
  const { activeConnection } = useProject();

  return (
    <StageWrapper>
      <StageInner>
        <StageBodyText>
          These settings should only be changed if you're absolutely positive on
          what they do.
        </StageBodyText>
        <StageBodyText>
          Some of these operations are <strong>irreversible</strong>.
        </StageBodyText>

        <AdvancedSetting
          action={() =>
            dispatch(
              showModal({
                visible: true,
                modal: ModalTypes.DELETION,
                additionalProps: {
                  entityType: EntityType.PORTAL,
                  entityId: portal?._id,
                  entityName: portal?.name,
                  connectionId: activeConnection?._id,
                },
              }),
            )
          }
          headerText={'Delete Portal'}
          subHeaderText={`Delete your portal completely.`}
          bodyText={`Be absolutely sure you wish to delete this portal before
          proceeding.`}
          actionButtonText={'Delete Portal'}
          actionButtonColor={themeContext.colors.general.red}
        />
      </StageInner>

      <ActionBar
        backButton={
          <FeatureButton
            action={() => {
              dispatch(updateActiveProjectStage(ProjectStage.CREATION));
            }}
            size={FeatureButtonSize.WIDE}
            color={themeContext.colors.general.sea}
            text={'Back to Overview'}
          />
        }
      />
    </StageWrapper>
  );
};

export default ProjectItemPortalConfigurationStage;
